import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class AlertService {

    /**
     * Create new alert.
     * 
     * @param {Alert} alert  
     * @return 
     */
    postAlert(alert, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/alert',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: alert
            };
            axios(instance).then((response) => {
                done();
            }).catch((error) => {
                reject(error);
            })
        });
    }
}